export const CALLBACK_URLS = {
    registeredCallbackUrl: 'https://www.example.com/notification',
    calledCallbackUrl: 'https://www.example.com/notification?subType=account&access_token=xyz123...',
}



// WEBPACK FOOTER //
// ./src/components/developerApi/developerSdk/Structure/Web/PubSubConstants.js